import { withTranslation } from 'react-i18next';
import AvailabilityStatistics from './AvailabilityStatistics.layout';

export default withTranslation('availability-reports')(AvailabilityStatistics);
